import { Link } from 'gatsby';
import { darken } from 'polished';
import styled, { css } from '../theme/styled-components';

const Base = css`
  display: flex;
  justify-content: center;
  font-size: 1rem;
  background: none;
  width: 100%;
  border: none;
  cursor: pointer;
  font-weight: ${props => props.theme.typography.button.fontWeight};
  font-size: ${props => props.theme.typography.button.fontSize};
  padding: ${props => props.theme.spacings.tiny}
    ${props => props.theme.spacings.medium};

  &:focus,
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  &:focus {
    outline: none;
  }
`;

const Primary = css`
  background-color: ${props => props.theme.colors.primary.base};

  &,
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.typography.light.base};
  }

  &:hover,
  &:focus {
    background-color: ${props =>
      darken(0.015, props.theme.colors.primary.base)};
  }
`;

const Secondary = css`
  background-color: ${props => props.theme.colors.secondary.base};

  &,
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.typography.dark.base};
  }

  &:hover,
  &:focus {
    background-color: ${props =>
      darken(0.015, props.theme.colors.secondary.base)};
  }
`;

export const PrimaryButton = styled.button`
  ${Base}
  ${Primary}
`;

export const SecondaryButton = styled.button`
  ${Base}
  ${Secondary}
`;

export const IconButton = styled.button`
  ${Base}
  line-height: 1;
  padding: ${props => props.theme.spacings.base};
  display: flex;
`;

const FullWidth = (margin: string) => `
  margin-left: -${margin};
  width: calc(100% + (${margin} * 2));
`;

export const ContactLink = styled(Link)`
  ${Base}
  ${Primary}
  ${props => FullWidth(props.theme.spacings.medium)}
  margin-top: ${props => props.theme.spacings.medium};

  ${media => media.theme.media.greaterThan('medium')`
      display: none;
  `}
`;

export const FormButton = styled.button`
  ${Base}
  ${Secondary}
  margin-top: ${props => props.theme.spacings.medium};

  ${media => media.theme.media.lessThan('downMedium')`
    ${props => FullWidth(props.theme.spacings.medium)}
  `}
`;

export const FlagButton = styled(Link)`
  ${Base}
  padding: ${props => props.theme.spacings.base};
  font-size: ${props => props.theme.typography.body.fontSize};
  line-height: 0;
  align-items: center;
  display: none;
  > * {
    margin-right: 0.25rem;
  }

  ${media => media.theme.media.greaterThan('medium')`
    display: flex;
  `}
`;

export const MenuItemButton = styled(FlagButton)`
  display: block;
  line-height: 1rem;
  color: ${props => props.theme.colors.typography.light.base};
  &:hover,
  &:focus {
    color: ${props => darken(0.015, props.theme.colors.typography.light.base)};
  }

  ${media => media.theme.media.greaterThan('medium')`
    padding: ${props => props.theme.spacings.base};
    color: ${props => props.theme.colors.typography.dark.base};
    &:hover,
    &:focus {
      color: ${props => darken(0.015, props.theme.colors.typography.dark.base)};
    }
  `}
`;

export const SubMenuToggleButton = styled.button`
  ${Base}
  padding: ${props => props.theme.spacings.base};
  font-size: 14px;
  line-height: 1rem;
  justify-content: flex-start;
  
  color: ${props => props.theme.colors.typography.light.base};
  &:hover,
  &:focus {
    color: ${props => darken(0.015, props.theme.colors.typography.light.base)};
  }

  ${media => media.theme.media.greaterThan('medium')`
    color: ${props => props.theme.colors.typography.dark.base};
    &:hover,
    &:focus {
      color: ${props => darken(0.015, props.theme.colors.typography.dark.base)};
    }
  `}
`;

export const MobileOnlySubMenuToggleButton = styled(SubMenuToggleButton)`
  ${media => media.theme.media.greaterThan('medium')`
    display: none;
  `}
`;
